export default __webpack_public_path__ + "static/media/cashapp.3f75e538.svg";